import { categories } from '@/mocks/categories';
import { videoArticles } from '@/mocks/videos';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  const getCount = (slug: string) => {
    if (slug === 'hot') return videoArticles.filter((v) => v.hot).length;
    return videoArticles.filter((v) => v.category === slug).length;
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            涵盖多种视频类型，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {displayCategories.map((cat, index) => (
            <div
              key={cat.id}
              className="animate-fade-in-up"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <CategoryCard
                name={cat.name}
                slug={cat.slug}
                icon={cat.icon}
                description={cat.description}
                count={getCount(cat.slug)}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}